import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { KEYBOARD_ARROW_DOWN_ROUNDED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const KeyboardArrowDownRoundedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={KEYBOARD_ARROW_DOWN_ROUNDED_GLYPH} />;
